import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar, CheckCircle, Baby, Home, Activity, Heart, BookOpen, Gift, GraduationCap, Monitor } from 'lucide-react';
import ServicesModal from '../ServicesModal/ServicesModal';
import './Charlasnutricionales.css';

const CharlasNutricionales = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const charlas = [
    {
      title: "Nutrición Infantil y Escolar",
      icon: Baby,
      topics: [
        "Loncheras saludables",
        "Prevención de anemia y malnutrición",
        "Hábitos alimentarios desde la infancia"
      ]
    },
    {
      title: "Alimentación Familiar Saludable",
      icon: Home,
      topics: [
        "Planificación de menús equilibrados",
        "Compras inteligentes",
        "Preparaciones prácticas y saludables"
      ]
    },
    {
      title: "Nutrición Deportiva",
      icon: Activity,
      topics: [
        "Alimentación pre y post entrenamiento",
        "Hidratación en el deporte",
        "Recuperación muscular",
        "Uso responsable de suplementos"
      ]
    },
    {
      title: "Prevención en Salud",
      icon: Heart,
      topics: [
        "Alimentación para diabetes, hipertensión y colesterol",
        "Control del peso saludable",
        "Fortalecimiento del sistema inmune"
      ]
    },
    {
      title: "Educación Nutricional General",
      icon: BookOpen,
      topics: [
        "Alimentación saludable en el día a día",
        "Lectura de etiquetas nutricionales",
        "Porciones adecuadas y balance nutricional"
      ]
    }
  ];

  const beneficios = [
    "Material educativo digital descargable",
    "Espacio de preguntas y respuestas en vivo",
    "Recomendaciones prácticas para aplicar de inmediato",
    "Certificado de participación (opcional)",
    "Seguimiento nutricional posterior (opcional)"
  ];

  return (
    <div className="charlas-container">
      <div className="charlas-content">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="charlas-header"
        >
          <h2 className="charlas-main-title">
            <span className="title-emoji">🥗</span>{' '}
            <span className="title-dark">Charlas</span>{' '}
            <span className="title-yellow">Nutricionales</span>
          </h2>
          <p className="charlas-subtitle">
            Dirigidas a la comunidad, colegios, familias y grupos en general.
          </p>
        </motion.div>

        <div className="charlas-grid">
          {charlas.map((charla, index) => {
            const IconComponent = charla.icon;
            const emojis = ['🧒', '👨‍👩‍👧‍👦', '🏃‍♂️', '🩺', '📚'];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index }}
                whileHover={{ scale: 1.03 }}
                className="charla-card"
              >
                <div className="charla-icon-wrapper">
                  <span className="charla-emoji">{emojis[index]}</span>
                  <IconComponent className="charla-icon" />
                </div>
                
                <h3 className="charla-title">{charla.title}</h3>

                <div className="charla-topics">
                  <ul className="topics-list">
                    {charla.topics.map((topic, idx) => (
                      <li key={idx} className="topic-item">
                        <CheckCircle className="check-icon" />
                        <span>{topic}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="modalidad-section"
        >
          <div className="modalidad-content">
            <div className="modalidad-item">
              <Monitor className="modalidad-icon" />
              <div>
                <strong>Modalidad:</strong> Presencial o Virtual
              </div>
            </div>
            <div className="modalidad-item">
              <Clock className="modalidad-icon" />
              <div>
                <strong>Duración por charla:</strong> 60 – 90 minutos
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="beneficios-section"
        >
          <h3 className="beneficios-title">
            <Gift className="beneficios-icon-title" />
            ¿Qué incluyen nuestras charlas?
          </h3>
          <div className="beneficios-grid">
            {beneficios.map((beneficio, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.7 + (0.1 * index) }}
                className="beneficio-item"
              >
                <CheckCircle className="beneficio-icon" />
                <span>{beneficio}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="cta-section"
        >
          <GraduationCap className="cta-icon" />
          <h3 className="cta-title">¿Deseas una charla para tu grupo o comunidad?</h3>
          <p className="cta-description">
            Diseñamos charlas personalizadas según las necesidades de tu colegio, familia o grupo comunitario.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cta-button"
            onClick={handleOpenModal}
          >
            <Calendar className="button-icon" />
            Solicita tu charla ahora
          </motion.button>
        </motion.div>
      </div>

      {/* Services Modal */}
      {isModalOpen && (
        <ServicesModal 
          isOpen={isModalOpen} 
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default CharlasNutricionales;